module.exports = __webpack_public_path__ + "media/images/athletes/4153-69a656c399d04193033f132e0f63a941.png";